import ApprovalsActivityUserTasksView from '@/components/approvals/ApprovalsActivityUserTasksView.vue'
import {
  ROUTE_USER_APPROVALS,
  ROUTE_USER_APPROVALS_ACTIVITY,
  ROUTE_USER_APPROVALS_ACTIVITY_USER_TASKS,
} from '@/router/routes/routeNames'

const ApprovalsView = () => import('@/components/approvals/ApprovalsView.vue')
const ApprovalsActivityView = () =>
  import('@/components/approvals/ApprovalsActivityView.vue')

const approvalsRoutes = [
  {
    name: ROUTE_USER_APPROVALS,
    path: '/users/approvals',
    component: ApprovalsView,
    meta: { resource: 'User', showGlobalHeader: false },
  },
  {
    name: ROUTE_USER_APPROVALS_ACTIVITY,
    path: '/users/approvals/activities/activity/:productId',
    props: true,
    component: ApprovalsActivityView,
    meta: { resource: 'User', showGlobalHeader: false },
  },
  {
    name: ROUTE_USER_APPROVALS_ACTIVITY_USER_TASKS,
    path: '/users/approvals/activities/activity/:productId/user/:userId',
    props: true,
    component: ApprovalsActivityUserTasksView,
    meta: { resource: 'User', showGlobalHeader: false },
  },
]

export default approvalsRoutes
